export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const FETCH_USER_ERROR = "FETCH_USER_ERROR";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";

export const FETCH_CURRENT_USER = "FETCH_CURRENT_USER";
export const FETCH_USER_BY_ID = "FETCH_USER_BY_ID";

export const UPDATE_USER = "UPDATE_USER";
